/*
 * 弹窗组件
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 16:25:35
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import React from 'react';
import classNames from 'classnames';
import Icons from 'Icon/Icons.less';
import Styles from './index.less';
var Modal = function (props) {
    var getStylesByProps = function () {
        return {
            width: props.width ? props.width : 960,
            height: props.width ? props.height : 560,
        };
    };
    return props.visibily ? (React.createElement("div", { className: Styles.modal },
        React.createElement("div", { style: getStylesByProps(), className: Styles.modalInner },
            React.createElement("div", { className: Styles.modalHeader },
                React.createElement("span", null, props.title),
                React.createElement("span", { onClick: function () { return props.onCancel(); }, className: classNames(Icons['icon-close'], Styles.modalClose) })),
            React.createElement("div", { className: Styles.modalBody }, props.children),
            React.createElement("div", { className: Styles.modalFooter },
                React.createElement("button", { onClick: function () { return props.onCancel(); }, className: Styles.modalCancel }, "\u53D6\u6D88"),
                React.createElement("button", { onClick: function () { return props.onOk(); }, className: Styles.modalOk }, "\u786E\u8BA4"))))) : null;
};
export default Modal;
